import { ListItem } from 'schema-dts'

const listItem = (
  position: number | string,
  id: string,
  name: string
): ListItem => ({
  '@type': 'ListItem',
  position,
  item: {
    '@id': id,
    name: name
  }
})

export default listItem
